import FooterSection from "assets/Footer";
import Navbar from "assets/Navbar";
import CardDesign from "components/cardDesign";
import NeedHelp from "components/productDetailsComponents/needHelp";
import ShareFollow from "components/productDetailsComponents/shareFollow";
import RevealOnScroll from "components/RevealOnScroll";
import ScrollToTopButton from "components/ScrollToTopButton";
import ProductDetailsShimmer from "components/shimmer/ProductDetailsShimmer";
import StockOut from "components/stockOut";
import useFooterData from "hook/useFooterData";
import useProductDetailsData from "hook/useProductDetailsData";
import useProductsByCatalogue from "hook/useProductsByCatalogue";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import {
  FaMinus,
  FaPlus,
  FaShoppingCart,
  FaTag,
  FaTruck,
  FaWhatsapp,
} from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
const getCollapsedText = (text, limit = 180) => {
  if (!text) return "";
  if (text.length <= limit) return text;
  return `${text.slice(0, limit)}...`;
};

const ProductDetails = () => {
  const { category, id } = useParams();
  const { products, loading, error } = useProductsByCatalogue(category);
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [colors, setColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const tabs = ["DESCRIPTION"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { footerData, loadingFooter } = useFooterData();
  const { detailsData, loadingDetails } = useProductDetailsData(id);
  const navigate = useNavigate();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showMoreDesc, setShowMoreDesc] = useState(false);
  const [showMoreExtraDesc, setShowMoreExtraDesc] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!detailsData) return;
    if (detailsData.size) {
      const sizeArray = detailsData.size.split(",").map((s) => s.trim()) || [];
      setSizes(sizeArray);
      setSelectedSize(sizeArray[0]);
    }
    if (detailsData.color) {
      const colorArray =
        detailsData.color.split(",").map((c) => c.trim()) || [];
      setColors(colorArray);
      setSelectedColor(colorArray[0]);
    }
    if (detailsData.variants?.length) {
      setVariants(detailsData.variants);

      const firstVariant = detailsData.variants[0];
      setSelectedVariant(firstVariant);
      setSelectedImage({
        type: "image",
        variant: firstVariant,
        src: firstVariant.images[0],
      });
    }
  }, [detailsData]);

  if (loadingDetails || loadingFooter)
    return (
      <ProductDetailsShimmer />
    );

  const allMedia = [
    ...variants.flatMap((variant) =>
      variant.images.map((img) => ({
        type: "image",
        variant,
        src: img,
      })),
    ),

    // Videos from item
    ...(detailsData?.video_path || []).map((video) => ({
      type: "video",
      variant: variants[0], // attach first variant
      src: video,
    })),
  ];
  const product = detailsData;
  const isOutOfStock = product.status === "unavailable";
  const currentTitle = selectedVariant?.title;
  const currentPrice = selectedVariant?.discount || selectedVariant?.flashPrice;
  const originalPrice = selectedVariant?.flashPrice;
  const freeVariantDelivery = selectedVariant?.freeVariantDelivery;

  const discountPercent =
    currentPrice > 0
      ? Math.ceil(((currentPrice - originalPrice) / currentPrice) * 100)
      : 0;

  const currentImage = selectedImage
    ? `https://backend.nuhababy.com/${selectedImage.src}`
    : "";

  const whatsappMessage = `
*${currentTitle}*
Price: ${originalPrice}৳
${window.location.href}
Thank You!
`;

  const handleAddToCart = (e) => {
    e.stopPropagation();
    setDrawerOpen(true);

    const cart = JSON.parse(localStorage.getItem("babyShop")) || [];
    const key = `${detailsData.item_id}_${selectedVariant.variant_id}`;
    const index = cart.findIndex((item) => item.cartKey === key);

    if (index !== -1) {
      cart[index].quantity += quantity;
    } else {
      cart.push({
        item_id: detailsData.item_id,
        catalogue: detailsData.catalogue,
        catalogue_title: detailsData.catalogue_title,
        color: detailsData.color,
        description: detailsData.description,
        extraDescription: detailsData.extraDescription,
        flashOffer: detailsData.flashOffer,
        quantity: quantity,
        material: detailsData.material,
        selectedColor: selectedColor,
        selectedPrice: selectedVariant.flashPrice,
        selectedSize: selectedSize,
        selectedTitle: selectedVariant.title,
        selectedVariant: selectedVariant,
        size: detailsData.size,
        status: detailsData.status,
        subCatalogue: detailsData.subCatalogue,
        subCatalogue_title: detailsData.subCatalogue_title,
        variant: detailsData.variant,
        video_path: detailsData.video_path,
        image: currentImage,
      });
    }

    localStorage.setItem("babyShop", JSON.stringify(cart));
  };

  const handleOrderNow = (e) => {
    handleAddToCart(e);
    navigate("/orderDetails");
  };

  return (
    <>
      <Helmet>
        <meta property="og:title" content={currentTitle} />
        <meta
          property="og:description"
          content={`Buy ${currentTitle} for ${currentPrice}৳`}
        />
        <meta property="og:image" content={currentImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="product" />
      </Helmet>

      <div className="min-h-screen bg-slate-50">
        <Navbar />
        <main className="mx-auto w-full px-4 py-6 sm:px-6">
          <RevealOnScroll>
            <section className="grid grid-cols-1 gap-5 rounded-lg bg-white p-4 shadow-sm ring-1 ring-slate-100 lg:grid-cols-[1.05fr_1fr] lg:p-6">
              <div className="w-full md:w-1/2 flex flex-col items-center">
                {currentImage && (
                  <div className="relative inline-block">
                    {selectedImage?.type === "image" ? (
                      <img
                        src={currentImage}
                        alt={currentTitle}
                        className={`md:h-[600px] h-[400px] object-cover rounded-lg mb-4 ${
                          isOutOfStock ? "opacity-40" : ""
                        }`}
                      />
                    ) : (
                      <video
                        src={currentImage}
                        controls
                        autoPlay
                        controlsList="nodownload noplaybackrate"
                        onContextMenu={(e) => e.preventDefault()}
                        className="md:h-[600px] h-[400px] object-cover rounded-lg mb-4"
                      />
                    )}

                    {isOutOfStock && <StockOut />}
                  </div>
                )}

                {allMedia.length > 1 && (
                  <div className="flex items-center justify-center gap-2 w-full overflow-hidden">
                    <div className="flex gap-2 overflow-x-auto">
                      {allMedia.map((item, idx) => {
                        const url = `https://backend.nuhababy.com/${item.src}`;

                        return item.type === "image" ? (
                          <img
                            key={idx}
                            alt={`Thumb ${idx}`}
                            src={url}
                            className={`w-20 h-20 object-cover rounded-md cursor-pointer border-2 ${
                              selectedImage?.src === item.src
                                ? "border-blue-500"
                                : "border-transparent"
                            }`}
                            onClick={() => {
                              setSelectedVariant(item.variant);
                              setSelectedImage(item);
                            }}
                          />
                        ) : (
                          <div
                            key={idx}
                            className={`relative w-20 h-20 border-2 rounded-md cursor-pointer overflow-hidden ${
                              selectedImage?.src === item.src
                                ? "border-blue-500"
                                : "border-transparent"
                            }`}
                            onClick={() => {
                              setSelectedVariant(item.variant);
                              setSelectedImage(item);
                            }}
                          >
                            <video
                              src={url}
                              className="w-full h-full object-cover"
                              muted
                            />

                            <div className="absolute inset-0 bg-black/30"></div>

                            <div className="absolute inset-0 flex items-center justify-center">
                              <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center shadow">
                                <div
                                  className="ml-[2px]"
                                  style={{
                                    width: 0,
                                    height: 0,
                                    borderTop: "6px solid transparent",
                                    borderBottom: "6px solid transparent",
                                    borderLeft: "8px solid black",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div>
                <p className="sm:text-lg  font-semibold uppercase tracking-wide text-blue-600">
                  {product?.mainTitle}
                </p>
                <h1 className="mt-1 text-sm sm:font-extrabold font-semibold text-slate-900 sm:text-2xl">
                  {currentTitle}
                </h1>
                <div className="mt-4 rounded-lg bg-slate-50 p-3">
                  <div className="flex flex-wrap items-center gap-3">
                    <p className="sm:text-2xl text-lg font-extrabold text-slate-900">
                      {originalPrice} TK
                    </p>
                    <p className="text-xs text-slate-500 line-through sm:text-base">
                      {currentPrice} TK
                    </p>
                    {discountPercent > 0 && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-rose-600 px-2 py-1 text-xs font-semibold text-white">
                        <FaTag />
                        {discountPercent}% OFF
                      </span>
                    )}
                  </div>
                  {freeVariantDelivery === 1 && (
                    <p className="mt-2 inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-1 text-xs font-semibold text-emerald-700">
                      <FaTruck />
                      Free Delivery
                    </p>
                  )}
                </div>

                <p className="mt-3 text-xs leading-relaxed text-slate-600 sm:text-base whitespace-pre-line">
                  {showMoreDesc
                    ? product?.description
                    : getCollapsedText(product?.description)}
                </p>
                {product?.description.length > 180 && (
                  <button
                    type="button"
                    onClick={() => setShowMoreDesc((prev) => !prev)}
                    className="mt-1 text-xs font-semibold text-blue-600"
                  >
                    {showMoreDesc ? "Show less" : "Read more"}
                  </button>
                )}
                <p className="mt-2 text-xs leading-relaxed text-slate-600 sm:text-base whitespace-pre-line">
                  {showMoreExtraDesc
                    ? product?.extraDescription
                    : getCollapsedText(product?.extraDescription)}
                </p>
                {product?.extraDescription.length > 180 && (
                  <button
                    type="button"
                    onClick={() => setShowMoreExtraDesc((prev) => !prev)}
                    className="mt-1 text-xs font-semibold text-blue-600"
                  >
                    {showMoreExtraDesc ? "Show less" : "Read more"}
                  </button>
                )}

                {variants.length > 1 && (
                  <div className="mb-2">
                    <div className="flex flex-wrap gap-2 mt-2">
                      {variants.length > 1 && (
                        <div className="sm:mb-5">
                          <p className="font-semibold mb-2 sm:text-base text-sm">
                            Select Variant
                          </p>

                          <select
                            value={selectedVariant?.variant_id || ""}
                            onChange={(e) => {
                              const selected = variants.find(
                                (v) => v.variant_id === Number(e.target.value),
                              );

                              if (!selected) return;

                              setSelectedVariant(selected);
                              setSelectedImage({
                                variant: selected,
                                src: selected.images[0],
                                imageIndex: 0,
                                type: "image",
                              });
                            }}
                            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-1 focus:ring-[#265fc9]"
                          >
                            {variants.map((variant) => (
                              <option
                                key={variant.variant_id}
                                value={variant.variant_id}
                              >
                                {variant.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {sizes.length > 0 && (
                  <div className="mb-2">
                    <p className="mb-1 text-sm font-semibold text-slate-700">
                      Size
                    </p>
                    {sizes.length && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {sizes.map((size) => (
                          <button
                            key={size}
                            onClick={() => setSelectedSize(size)}
                            className={`rounded-md border px-3 py-2 text-xs font-bold transition sm:text-sm ${
                              selectedSize === size
                                ? "border-blue-500 bg-blue-50 text-blue-700"
                                : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
                            }`}
                          >
                            {size}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Color Selection */}
                <div className="mb-3">
                  {colors.length > 0 && (
                    <div>
                      <p className="mb-1 text-sm font-semibold text-slate-700">
                        Color
                      </p>
                      {colors.length && (
                        <div className="flex flex-wrap gap-2 mt-2">
                          {colors.map((color) => (
                            <button
                              key={color}
                              onClick={() => setSelectedColor(color)}
                              className={`inline-flex items-center gap-2 rounded-md border px-2.5 py-2 text-xs font-bold transition sm:text-sm ${
                                selectedColor === color
                                  ? "border-blue-500 bg-blue-50 text-blue-700"
                                  : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
                              }`}
                            >
                              {color}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="rounded-lg border border-slate-200 bg-white p-3 mt-3">
                    <p className="text-sm font-semibold text-slate-700">
                      Product Info
                    </p>
                    <dl className="mt-2 space-y-2 text-sm">
                      <div className="flex  justify-between gap-4">
                        <dt className="text-slate-500">Material</dt>
                        <dd className="font-semibold text-slate-800 sm:text-base text-xs">
                          {product?.material}
                        </dd>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <dt className="text-slate-500">Weight</dt>
                        <dd className="font-semibold text-slate-800">
                          {product.weight / 1000} KG
                        </dd>
                      </div>
                    </dl>
                  </div>

                  {!isOutOfStock && (
                    <>
                      <div className="flex justify-between items-end w-full gap-2">
                        <div className="mt-4 flex-none ">
                          <p className="mb-1 text-sm font-semibold text-slate-700">
                            Quantity
                          </p>
                          <div className="inline-flex items-center rounded-md border border-slate-300 bg-white">
                            <button
                              type="button"
                              disabled={quantity === 1}
                              onClick={() =>
                                setQuantity((q) => Math.max(1, q - 1))
                              }
                              className="inline-flex h-9 w-9 items-center justify-center disabled:cursor-not-allowed disabled:opacity-40"
                            >
                              <FaMinus className="text-xs" />
                            </button>
                            <span className="inline-flex min-w-10 items-center justify-center text-sm font-bold">
                              {quantity}
                            </span>
                            <button
                              type="button"
                              onClick={() => setQuantity((q) => q + 1)}
                              className="inline-flex h-9 w-9 items-center justify-center"
                            >
                              <FaPlus className="text-xs" />
                            </button>
                          </div>
                        </div>

                        <div className="flex-1">
                          <button
                            lang="bn"
                            type="button"
                            onClick={handleOrderNow}
                            className="w-full rounded-md bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700"
                          >
                            অর্ডার করুন
                          </button>
                        </div>
                      </div>
                      <div className="flex gap-2 sm:mt-[20px] mt-[15px] mb-3">
                        <button
                          lang="bn"
                          type="button"
                          onClick={handleAddToCart}
                          className="flex-1 min-w-0 inline-flex items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2.5 text-xs sm:text-sm font-semibold text-gray-700 transition hover:bg-gray-100"
                        >
                          <FaShoppingCart />
                          Add to Cart
                        </button>
                        <a
                          href={`https://wa.me/8801971787661?text=${encodeURIComponent(whatsappMessage)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-none sm:flex-1"
                        >
                          <button
                            lang="bn"
                            className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-emerald-500 px-4 py-2.5 text-xs sm:text-sm font-semibold text-white transition hover:bg-emerald-600 sm:w-full"
                          >
                            <FaWhatsapp />
                            WHATSAPP এ অর্ডার করুন
                          </button>
                        </a>
                      </div>  
                    </>
                  )}
                </div>
              </div>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delayMs={60}>
            <section className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <NeedHelp />
              <ShareFollow />
            </section>
          </RevealOnScroll>

          {/* Related Products */}
          <div className="flex mt-5 items-center border-b border-gray-200 w-full px-4 mb-5 container mx-auto">
            <div className="flex items-center space-x-2 relative pb-2">
              <FaShoppingCart className="text-xl text-black" />
              <span className="text-lg font-semibold text-black">
                সংশ্লিষ্ট প্রোডাক্ট
              </span>
              <div className="absolute -bottom-0.5 left-0 w-full h-[2px] bg-green-600 rounded-full"></div>
            </div>
          </div>
          <div className="py-4">
            <CardDesign likeData={products} loading={loading} error={error} />
          </div>
        </main>
        <FooterSection />
        {showScrollTop && <ScrollToTopButton />}
      </div>
    </>
  );
};

export default ProductDetails;
